export const secretPlaceholder = '••••••••••••••••••••';
